<script>
    import { Member, SettingsPassport } from "shared/Models/memberClasses";
    import f9select from "inputs/f9select.vue";
    import f9date from "inputs/f9date.vue";
    import moment from "moment";
    import f9input from 'inputs/f9input.vue';
    import f9button from "inputs/f9button.vue";
    import f9field from "inputs/f9field.vue";

    export default {
        props: {
            member: Member,
            passport: SettingsPassport,
            removePassport: Function,
            saved: Boolean,
            allowRemove: {
                type: Boolean,
                default: true
            },
            notRequired: Boolean,
            validationScope: {
                type: String,
                default: "passport-fields"
            },
            displayIssueDate: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                issuingCountry: "",
                nationality: "",
                changed: false
            };
        },
        components: {
            f9select,
            f9date,
            f9button,
            f9input,
            f9field
        },
        methods: {
            onChange(val) {
                this.$emit('change', val);
                this.changed = true;
            }
        },
        computed: {
            maxExpirationDate: function() {
                return moment().add("years", 30).toDate();
            },
            today() {
                return new Date();
            }
        },
        watch: {
            saved(val) {
                if(val) {
                    this.changed = false;
                }
            }
        },
        inject: ["$validator"]
    };
</script>

<template> 
    <div class="passportInfoContainer" @input="$emit('input', passport)" @change="onChange(passport)">
        
        <!-- passport number -->
        <f9field>
            <div slot="label" class="passport-label-flex">
                <label for="passport-number">
                    <span class="slider-label">Passport Number*</span>
                </label>
                <f9button nostyle @click="removePassport(passport)" class="removePassportContainer" v-if="allowRemove">
                    <span class="addRemovePassport">Remove passport</span><img src="~images/Loyalty/Icons/remove.svg" alt="">
                </f9button>
            </div>
            <f9input :saved="!changed" v-model="passport.documentNumber" v-validate="(!notRequired ? 'required|' : '') +'alpha_num|max:35'" 
                :data-vv-scope="validationScope" name="passport_number"></f9input>
        </f9field>

         <!-- Issuing Country -->
        <f9field label="Issuing Country*">
            <f9select :saved="!changed" v-model="passport.issuingCountry" v-validate="!notRequired ? 'required' : ''" 
                :data-vv-scope="validationScope" name="passport_issuing_country">
                <option data-cs-mask v-for="item in member.resourceData.countries" :key="item.code" :value="item.code">{{item.name}}</option> 
            </f9select>
        </f9field>

        <!-- Nationality-->
        <f9field label="Nationality*">
            <f9select :saved="!changed" v-model="passport.nationality" v-validate="!notRequired ? 'required' : ''" 
                :data-vv-scope="validationScope" name="passport_issuing_nationality">
                <option data-cs-mask v-for="item in member.resourceData.countries" :key="item.code" :value="item.code">{{item.name}}</option> 
            </f9select>
        </f9field>

        <div class="slider-form-row">
            <!-- Issue Date -->
            <f9field label="Issue Date*" v-if="displayIssueDate" half>
                <f9date :saved="!changed" :open-date="today" v-model="passport.issueDate" name="passport_issue_date"
                    :data-vv-scope="validationScope" :required="!notRequired">
                </f9date>
            </f9field>

            <!-- Expiration Date -->
            <f9field label="Expiration Date*" half>
                <f9date :saved="!changed" :open-date="today" v-model="passport.expirationDate" name="passport_expiry_date"
                    :data-vv-scope="validationScope" :min-date="today" :max-date="maxExpirationDate" :required="!notRequired">
                </f9date>
            </f9field>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .passportInfoContainer {
        margin-left: 10px;
        width: calc(~"100% - 10px");
    }

    .addRemoveCardContainer {
        height: 20px;
    }

    .slider-label {
        padding-bottom: 5px;
    }

    .expiration {
        display: flex;
        margin-bottom: 11px;
    }

    .passport-label-flex {
        display: flex;
        width: 100%;
        justify-content: space-between;
        color: @frontier-gray-dark;
    }

    .removePassportContainer {
        color: @frontier-green;
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        cursor: pointer;
        padding-bottom: 3px;
        height: 20px;
        white-space: nowrap;
    }

    .addRemovePassport {
        margin-right: 5px;
    }

    img {
        width: 10px;
        height: 10px;
    }

    @media @tablet {
        .passportInfoContainer {
            .expiration {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
            }
        }
    }
</style>

